module.exports = __webpack_public_path__ + "assets/circle-info-979589.svg";